import React, { useState } from 'react';
import StockOverviewWidget from '../components/LogisticWidgets/StockOverviewWidget';
import ProductionStatusWidget from '../components/LogisticWidgets/ProductionStatusWidget';
import DeliveryTrackingWidget from '../components/LogisticWidgets/DeliveryTrackingWidget';
import DistributionMatrixWidget from '../components/LogisticWidgets/DistributionMatrixWidget';
import { Calendar, Map as MapIcon, Filter } from 'lucide-react';
import { useIsCompactUser } from '../helpers/currentUser';

const LogisticAndStock = () => {
  const [globalFilters, setGlobalFilters] = useState({
    region: 'All Regions',
    dateRange: 'This Month'
  });

  // Compact layout is gated on the authorized user's NIK. Baseline otherwise.
  const compact = useIsCompactUser();

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', padding: compact ? '12px 16px' : '24px 32px' }}>
      {/* Header & Global Filters */}
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: compact ? '16px' : '32px', gap: '16px' }}>
        <div>
          <h1 style={{ fontSize: '24px', fontWeight: '800', color: '#1e293b', margin: 0, letterSpacing: '-0.025em' }}>Total Logistik & Manage Stock</h1>
          <p style={{ color: '#64748b', fontSize: '14px', marginTop: '4px', marginBottom: 0 }}>Pantau pergerakan gudang, status produksi, dan pengiriman secara real-time.</p>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', background: '#fff', padding: '8px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 12px', borderRight: '1px solid #f1f5f9' }}>
            <MapIcon size={16} color="#94a3b8" />
            <select 
              style={{ background: 'transparent', border: 'none', fontSize: '14px', fontWeight: '500', color: '#334155', outline: 'none', cursor: 'pointer' }}
              value={globalFilters.region}
              onChange={(e) => setGlobalFilters({ ...globalFilters, region: e.target.value })}
            >
              <option>All Regions</option>
              <option>Jawa Barat</option>
              <option>Jawa Tengah</option>
              <option>Jawa Timur</option>
            </select>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 12px', borderRight: '1px solid #f1f5f9' }}>
            <Calendar size={16} color="#94a3b8" />
            <select 
              style={{ background: 'transparent', border: 'none', fontSize: '14px', fontWeight: '500', color: '#334155', outline: 'none', cursor: 'pointer' }}
              value={globalFilters.dateRange}
              onChange={(e) => setGlobalFilters({ ...globalFilters, dateRange: e.target.value })}
            >
              <option>Today</option>
              <option>This Week</option>
              <option>This Month</option>
              <option>This Year</option>
            </select>
          </div>
          <button style={{ padding: '8px', background: 'transparent', border: 'none', cursor: 'pointer', color: '#475569', borderRadius: '8px', display: 'flex' }}
            onMouseOver={(e) => e.currentTarget.style.background = '#f1f5f9'}
            onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}
          >
            <Filter size={16} />
          </button>
        </div>
      </div>

      {/* NEW: Distribution Sandbox Matrix */}
      <div style={{ width: '100%' }}>
        <DistributionMatrixWidget filters={globalFilters} />
      </div>

      {/* Dashboard Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: compact ? '16px' : '24px', marginBottom: compact ? '16px' : '24px' }}>
        {/* Left Column: Stock */}
        <div style={{ gridColumn: 'span 2' }}>
          <StockOverviewWidget filters={globalFilters} />
        </div>
        
        {/* Right Column: Production */}
        <div style={{ gridColumn: 'span 1' }}>
          <ProductionStatusWidget filters={globalFilters} />
        </div>
      </div>

      {/* Full width bottom row for Delivery Tracking */}
      <div style={{ width: '100%' }}>
        <DeliveryTrackingWidget filters={globalFilters} />
      </div>
    </div>
  );
};

export default LogisticAndStock;
